import React from 'react';
import PropTypes from 'prop-types';

import { Image } from '$partials/media';
import { useLocale } from '$contexts/locale.jsx';

const defaultImage = {
    src: '/images/default-x1.jpg',
    x2: '/images/default-x2.jpg',
};

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ArticleStandardListingItem = ({
    listingFields,
    logo,
    tags,
    title,
    type,
    url
}) => {
    const { formatURI } = useLocale();

    return (
        <a
            className='w-full'
            href={formatURI(url)}>
            <figure className='w-full relative'>
                <Image
                    className='rounded-button'
                    {...(listingFields?.listingImage || defaultImage)} />
                {logo && (
                    <div className='w-[80px] h-[80px] relative z-10 top-0 -mt-40 float-right mr-20'>
                        <div className='bg-white rounded-full h-full w-full px-10'>
                            <div
                                className='bg-contain bg-center	bg-no-repeat rounded-full w-full h-full'
                                style={{backgroundImage: `url(${logo?.src})`}}
                                title={logo?.title} />
                        </div>
                    </div>
                )}
            </figure>
            <div className='mt-20 flex flex-col'>
                {tags?.items?.length > 0 && (
                    <div className={`flex items-center mb-13 ${type === 'RelatedCarousel' ? 'mb-13' : 'mb-10'}`}>
                        {tags.items[0]?.node?.icon && (
                            <div
                                className='mr-10'
                                style={{
                                    fontSize: '18px',
                                    width: `${(tags.items[0]?.node?.icon.width / tags.items[0]?.node?.icon.height)}em` ,
                                    maxWidth: '100%'
                                }}>
                                <Image
                                    {...tags.items[0]?.node?.icon}
                                    loading={''}/>
                            </div>
                        )}
                        <p className='text-orange type-style-7'>{tags.items[0]?.node?.title}</p>
                    </div>
                )}
                <h3 className='type-style-4'>
                    {title}
                </h3>
            </div>
            {listingFields?.listingText && (
                <div className='mt-18 md:mt-8 type-style-5 text-light-grey'>
                    {listingFields.listingText}
                </div>
            )}
        </a>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    listingFields: PropTypes.shape({
        listingImage: PropTypes.object,
        listingText: PropTypes.string,
    }),
    logo: PropTypes.object,
    tags: PropTypes.shape({
        items: PropTypes.array,
    }),
    title: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
    __typename: PropTypes.string,
};

ArticleStandardListingItem.propTypes = propTypes;

export default ArticleStandardListingItem;
